<template>
    
    <div class="add-to-cart">        

        <template v-if="variation.isPurchasable">
            <!-- bouton normal -->
            <div class="add-to-cart__content">
                <div class="add-to-cart__qty">
                    <input class="input-text qty text"
                        type="number"
                        min="0" 
                        v-model="quantity" />
                </div>
                <div class="add-to-cart__btn" v-if="!processing">
                    <button class="woocommerce-button button add_to_cart_button"
                        type="button"
                        title="Ajouter au panier"
                        :disabled="disabled"
                        v-on:click="addToCart()">
                        <span class="fa fa-shopping-cart"></span>
                    </button>
                </div>
                <div class="add-to-cart__spinner" v-if="processing">
                    <Spinner></Spinner>
                </div>
            </div>
        </template>

        <template v-else>
            <template v-if="variation.notPurchasableReason === 'IS_BIOCIDE'">
                <a :href="certibiocideUploadUrl" class="title__wrapper" target="_blank">
                    <span>Fournir<br/>certibiocide</span>
                </a>
            </template>

            <template v-else-if="variation.notPurchasableReason === 'IS_REPLACE'">
                <a class="title__wrapper" :href="linkRemplacement">
                    <span>Remplacé</span>
                </a>
            </template>

            <template v-else-if="variation.notPurchasableReason === 'IS_INACTIVE'">
                <span>Indisponible</span>
            </template>

            <template v-else-if="variation.notPurchasableReason === 'IS_PUNCHOUT_WITHOUT_UNSPSC'">
                <span class="title__wrapper">UNSPSC inconnu</span>
            </template>

            <template v-else>
                <span>-</span>
            </template>
        </template>

    </div>

</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue';

import api from '@/api/wp/cart'
import Spinner from '@/components/spinner/Spinner.vue'

export const ADD_TO_CART_EVENT = 'addtocart'

export const CartBus = new Vue();

export default {

    data: function() {
        return {
            processing: false,
            quantity: 1
        }
    },

    props: {
        article: Object,
        variation: Object
    },

    computed: {

        ...mapState({
            currentClient: state => state.clients.current
        }),

        certibiocideUploadUrl: function () {
            return this.$setting('CERTIBIOCIDE_UPLOAD_URL')
        },

        css: function () {
            return ''
        },

        disabled: function () {
            return this.processing
        },

        linkRemplacement: function () {
            return ( this.article.slugRemplacement ) ? this.$config.SITE_URL + '/product/' + this.article.slugRemplacement : null
        }
    },

    methods: {        

        addToCart: function() {

            this.processing = true

            api.postArticle(this.article.id, this.quantity, this.variation.id)          
                .then( () => {
                    this.$notify.success(this.article.title + " ajouté au panier")
                    this.$emit(ADD_TO_CART_EVENT, {})
                    CartBus.$emit(ADD_TO_CART_EVENT, {})
                })
                .catch( () => this.$notify.error("Impossible d'ajouter " + this.article.title + " au panier") )
                .finally( () => this.processing = false )
        }
    },

    components: {
        Spinner
    }
}
</script>

<style scoped>

.add-to-cart {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.add-to-cart .add-to-cart__btn button,
.add-to-cart .add-to-cart__btn .button {
    margin: 0 !important;
    min-width: 3.5rem;
    width: 3.5rem;
}

.add-to-cart .add-to-cart__content {
  display: flex;
  align-items: center;
}

.add-to-cart .add-to-cart__qty {
    margin-right: 0.5rem;
    max-width: 4.8rem;
    min-width: 4rem;
}

.add-to-cart .add-to-cart__qty input[type="number"],
.add-to-cart .add-to-cart__qty .input-text {
    width: 100%;
}


.add-to-cart .add-to-cart__spinner {
    position: relative;
    overflow: hidden;
    height: 3rem;
    width: 3.5rem;
}

.add-to-cart .add-to-cart__spinner .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(.26);
}

</style>